module.exports = __webpack_public_path__ + "static/media/siri14.8ed812ae.jpg";